<template>
  <div class="home">
    <Navbar :is-active="6"></Navbar>
    <div class="body">
      <MesasSidebar active="dashboard" />
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <div>
            <h2>Resumen</h2>
            <p class="page__lead">KPIs de mesas, ventas QR y calificaciones del período.</p>
          </div>
        </div>

        <div class="page__filters dash-filters">
          <label class="dash-field">
            <span>Desde</span>
            <input type="date" v-model="desde" />
          </label>
          <label class="dash-field">
            <span>Hasta</span>
            <input type="date" v-model="hasta" />
          </label>
          <button class="btn-search" :disabled="busy" @click="loadDashboard">
            {{ busy ? 'Cargando…' : 'Buscar' }}
          </button>
        </div>

        <p v-if="error" class="dash-error">{{ error }}</p>

        <template v-if="kpis">
          <section class="kpi-grid">
            <article class="kpi-card kpi-card--accent">
              <p class="kpi-card__label">Ventas cobradas</p>
              <h3 class="kpi-card__value">S/ {{ money(kpis.sales_total) }}</h3>
              <p class="kpi-card__meta">{{ kpis.payments_count }} pagos</p>
            </article>
            <article class="kpi-card">
              <p class="kpi-card__label">Ticket promedio</p>
              <h3 class="kpi-card__value">S/ {{ money(kpis.avg_ticket) }}</h3>
              <p class="kpi-card__meta">por cobro</p>
            </article>
            <article class="kpi-card">
              <p class="kpi-card__label">Propinas</p>
              <h3 class="kpi-card__value">S/ {{ money(kpis.tips_total) }}</h3>
              <p class="kpi-card__meta">en el período</p>
            </article>
            <article class="kpi-card">
              <p class="kpi-card__label">Comisión plataforma</p>
              <h3 class="kpi-card__value">S/ {{ money(kpis.platform_fee_total) }}</h3>
              <p class="kpi-card__meta">fee cobrado</p>
            </article>
            <article class="kpi-card">
              <p class="kpi-card__label">Mesas ocupadas</p>
              <h3 class="kpi-card__value">{{ kpis.occupied_tables }} / {{ kpis.tables_total }}</h3>
              <p class="kpi-card__meta">{{ kpis.open_orders }} comandas abiertas</p>
            </article>
            <article class="kpi-card">
              <p class="kpi-card__label">Pendiente en sala</p>
              <h3 class="kpi-card__value">S/ {{ money(kpis.pending_amount) }}</h3>
              <p class="kpi-card__meta">ítems sin pagar</p>
            </article>
            <article class="kpi-card">
              <p class="kpi-card__label">Rating restaurante</p>
              <h3 class="kpi-card__value">{{ kpis.avg_rating_restaurant || '—' }}</h3>
              <p class="kpi-card__meta">promedio 1–5</p>
            </article>
            <article class="kpi-card">
              <p class="kpi-card__label">Rating mesero</p>
              <h3 class="kpi-card__value">{{ kpis.avg_rating_waiter || '—' }}</h3>
              <p class="kpi-card__meta">{{ kpis.ratings_count }} calificaciones</p>
            </article>
          </section>

          <section class="dash-panels">
            <div class="dash-panel">
              <h3>Ventas por día</h3>
              <div class="chart-wrap" v-if="chartHeader.length">
                <BarChart :key="chartKey" :header="chartHeader" :body="chartBody" :width="400" :height="220" />
              </div>
              <p v-else class="dash-empty">Sin ventas en el rango.</p>
            </div>

            <div class="dash-panel">
              <h3>Top platos</h3>
              <table class="dash-table" v-if="topProducts.length">
                <thead>
                  <tr>
                    <th>Plato</th>
                    <th>Cant.</th>
                    <th>Monto</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, i) in topProducts" :key="i">
                    <td>{{ p.name }}</td>
                    <td>{{ p.qty }}</td>
                    <td>S/ {{ money(p.amount) }}</td>
                  </tr>
                </tbody>
              </table>
              <p v-else class="dash-empty">Aún no hay platos pagados en el período.</p>
            </div>
          </section>
        </template>

        <p v-else-if="!busy && !error" class="dash-empty">Elige un rango y pulsa Buscar.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Navbar from '@/components/NavBar.vue'
import MesasSidebar from '@/components/MesasSidebar.vue'
import OpenArrow from '@/components/OpenArrow.vue'
import BarChart from '@/components/BarChart.vue'

function todayISO() {
  const d = new Date()
  return d.toISOString().slice(0, 10)
}

function daysAgoISO(n) {
  const d = new Date()
  d.setDate(d.getDate() - n)
  return d.toISOString().slice(0, 10)
}

export default {
  name: 'PosDashboard',
  components: { Navbar, MesasSidebar, OpenArrow, BarChart },
  data() {
    return {
      desde: daysAgoISO(6),
      hasta: todayISO(),
      busy: false,
      error: '',
      kpis: null,
      topProducts: [],
      chartHeader: [],
      chartBody: [],
      chartKey: 0
    }
  },
  computed: {
    companyId() {
      return parseInt(localStorage.getItem('company_id'), 10)
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/login')
      return
    }
    this.loadDashboard()
  },
  methods: {
    money(v) {
      return (Math.round((Number(v) + Number.EPSILON) * 100) / 100).toFixed(2)
    },
    async loadDashboard() {
      this.busy = true
      this.error = ''
      try {
        const res = await axios.get('general/table/dashboard', {
          params: {
            company_id: this.companyId,
            desde: this.desde,
            hasta: this.hasta
          }
        })
        if (!res.data || !res.data.success) {
          this.kpis = null
          this.error = (res.data && res.data.message) || 'No se pudo cargar el resumen.'
          return
        }
        const data = res.data.data || {}
        this.kpis = data.kpis || null
        this.topProducts = data.top_products || []
        const days = data.sales_by_day || []
        this.chartHeader = days.map(function (d) {
          return (d.date || '').slice(5)
        })
        this.chartBody = days.map(function (d) {
          return Number(d.total) || 0
        })
        this.chartKey += 1
      } catch (e) {
        this.kpis = null
        this.error = (e.response && e.response.data && e.response.data.message) || e.message || 'Error de red'
      } finally {
        this.busy = false
      }
    }
  }
}
</script>

<style scoped>
.body { width: 100%; display: flex; }
.body__containt {
  min-height: 87vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 28px 40px;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  min-width: 0;
}
.page__lead {
  margin: 4px 0 0;
  font-size: 13px;
  color: #777;
}
.page__title {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0 0 12px;
}
.page__title h2 {
  margin: 0;
  font-weight: 600;
  color: #ff3128;
  font-size: 25px;
}
.dash-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
  margin: 0 0 14px;
}
.dash-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #666;
}
.dash-field input {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 13px;
  background: #fff;
}
.btn-search {
  border: none;
  border-radius: 9px;
  padding: 10px 16px;
  background: #ff3128;
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
}
.btn-search:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}
.kpi-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 14px 16px;
}
.kpi-card--accent {
  border-color: #ffd0cd;
  background: #fff7f6;
}
.kpi-card__label {
  margin: 0;
  font-size: 12px;
  color: #888;
}
.kpi-card__value {
  margin: 6px 0 2px;
  font-size: 22px;
  color: #1a1a1a;
  font-weight: 700;
}
.kpi-card--accent .kpi-card__value {
  color: #ff3128;
}
.kpi-card__meta {
  margin: 0;
  font-size: 12px;
  color: #999;
}
.dash-panels {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 14px;
}
.dash-panel {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 16px;
}
.dash-panel h3 {
  margin: 0 0 12px;
  font-size: 15px;
  color: #333;
}
.chart-wrap {
  max-width: 100%;
  overflow: auto;
}
.dash-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.dash-table th,
.dash-table td {
  text-align: left;
  padding: 8px 6px;
  border-bottom: 1px solid #f0f0f0;
}
.dash-table th {
  color: #888;
  font-weight: 600;
  font-size: 12px;
}
.dash-empty {
  color: #999;
  font-size: 13px;
  padding: 12px 0;
}
.dash-error {
  color: #c62828;
  background: #ffebee;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
}
@media (max-width: 1100px) {
  .kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dash-panels {
    grid-template-columns: 1fr;
  }
}
</style>
